var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row-title-btn"},[_c('v-card-title',[_vm._v("Tipos de Subasta")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }